module.exports = "<ul class=\"nav nav-pills\">\r\n  <li ui-sref-active=\"active\">{{$ctrl.product}}\r\n    <a ui-sref=\"app.product.material.spec\">\r\n      Spec\r\n    </a>\r\n  </li>\r\n  <li ui-sref-active=\"active\">\r\n    <a ui-sref=\"app.product.material.pricing\">\r\n      Pricing\r\n    </a>\r\n  </li>\r\n</ul>\r\n<div ui-view></div>\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n"


/*****************
 ** WEBPACK FOOTER
 ** ./client/app/modules/products/components/material-mode/template.html
 ** module id = 464
 ** module chunks = 0
 **/